module.exports = __webpack_public_path__ + "static/media/FlagCheckered.f5fe823c.svg";